import {Component} from '@angular/core';
import {AuthService} from './modules/core/auth/auth.service';
import {Router} from '@angular/router';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'biilog_web_gerencial_v2';

  public ambiente = false;

  constructor(private authService: AuthService, private router: Router) {
    this.ambiente = environment.production;
  }

  ngOnInit() {


    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/home/login']);
    }

  }


}
